// Auto-generated mapping of contract address to NFTfi API collection name
export const NFTFI_COLLECTION_NAME_MAP: Record<string, string> = {
  "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb": "Cryptopunks",
  "0xb7f7f6c52f2e2fdb1963eab30438024864c313f6": "Wrapped CryptoPunks",
  "0x000000000000003607fce1ac9e043a86675c5c2f": "Cryptopunks 721",
  "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d": "Bored Ape Yacht Club",
  "0x60e4d786628fea6478f785a6d7e704777c86a7c6": "Mutant Ape Yacht Club",
  "0xba30e5f9bb24caa003e9f2f0497ad287fdf95623": "Bored Ape Kennel Club",
  "0xed5af388653567af2f388e6224dc7c4b3241c544": "Azuki",
  "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b": "clone x - x takashi murakami",
  "0x8a90cab2b38dba80c64b7734e58ee1db38b8992e": "Doodles",
  "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a": "Chromie Squiggle by Snowfro",
  "0x1a92f7381b9f03921564a437210bb9396471050c": "cool cats",
  "0x23581767a106ae21c074b2276d25e5c3e136a68b": "Moonbirds",
  "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb": "Veefriends",
  "0xbd3531da5cf5857e7cfaa92426877b022e612cf8": "Pudgy Penguins",
  "0x524cab2ec69124574082676e6f654a18df49a048": "Lil Pudgys",
  "0x5af05d7ba0543edb0a20ff3d65d0c4db9bca25a5": "Milady Maker",
  "0xd4e4078ca3495de5b1d4db434bebc5a986197782": "Autoglyphs",
  "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270": "Anticyclone By William Mapan",
  "0x9cf0ab1cc434db83097b7e9c831a764481dec747": "Aligndraw"
};
